
export function getReactEnv() {
    let env = process.env.REACT_APP_ENV;
    if (!env) {
      env = 'dev';
    }
    return env;
  }